module.exports = __webpack_public_path__ + "img/Northern Marianas Islands.19d23368.svg";